import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/bundle';
import 'swiper/css/pagination';
import { useDispatch, useSelector } from 'react-redux';
import { setPayWithLinkinEmail, setSelectStoredCard } from '@src/store/slice/mobilExpressSlice';
import React, { useEffect, useMemo, useState } from 'react';
import CreditCards from '@src/pages/ticketRestaurant/balanceUpload/payment/CreditCards';
import '@src/styles/autoUploadInstruction/paymentType.scss';
import PropTypes from 'prop-types';

import { Text, useText } from '@src/components';

const SavedCreditCards = ({ setPayLater = () => {}, propIsOn = false }) => {
  const isMobil = useMediaQuery({ query: '(max-width: 991.98px)' });
  const { storedCard, selectedStoredCard } = useSelector((state) => state?.mobilExpress);
  const dispatch = useDispatch();
  const [isOn, setIsOn] = useState(false);

  const yes2Text = useText('yes2');
  const no2Text = useText('no2');

  const toggleSwitch = () => {
    setIsOn(!isOn);
  };

  useEffect(() => {
    if (isOn) setPayLater(isOn);
    console.log('isOn', isOn);
  }, [isOn]);

  useEffect(() => {
    if (isOn !== propIsOn) setIsOn(propIsOn);
  }, [propIsOn]);

  const activeCard = useMemo(() => {
    dispatch(setSelectStoredCard(null));
    if (storedCard.length === 0) {
      return {};
    }
    const defaultFlag = storedCard.find((s) => s.unlimited_Contract && s.default_Flag);
    dispatch(setPayWithLinkinEmail(false));
    if (defaultFlag?.cardToken) {
      dispatch(setSelectStoredCard(defaultFlag?.cardToken));
    }
    return defaultFlag;
  }, [storedCard]);

  const storedCardFilter = useMemo(() => {
    return storedCard.filter((s) => s.cardToken !== activeCard?.cardToken);
  }, [activeCard]);

  const onClickCard = (e) => {
    dispatch(setSelectStoredCard(e));
    dispatch(setPayWithLinkinEmail(false));
  };

  if (storedCard.length === 0) {
    return null;
  }

  return (
    <>
      <span style={{ fontWeight: 'bold' }}>
        <Text t="myRegisteredCards" />
      </span>
      {isMobil ? (
        <Swiper
          slidesPerView="auto"
          slideToClickedSlide={true}
          spaceBetween={isMobil ? 16 : 40}
          className="mySwiper stored-card-wrapper"
        >
          {storedCard.map((item) => (
            <SwiperSlide key={item?.id}>
              <CreditCards
                selectedStoredCard={selectedStoredCard}
                cardItem={item}
                tCar={true}
                onClickCard={onClickCard}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div key={'credit-card-list-radio-group'}>
          <div className="stored-card-wrapper-grid">
            {storedCard.map((item) => (
              <div className="stored-card-wrapper-grid-item" style={{ margin: 10 }} key={item?.id}>
                <CreditCards
                  selectedStoredCard={selectedStoredCard}
                  cardItem={item}
                  tCar={true}
                  onClickCard={onClickCard}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      <div
        className="vehicle-managemet-add-fleet-limit-new-card-later"
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: 10,
          alignItems: 'center',
          fontSize: 14,
          fontWeight: 'normal',
          color: '#1d2228',
          textAlign: 'left',
        }}
      >
        <Text t="iWantToCompleteMyPaymentLaterWith" />
        <button style={{ backgroundColor: 'transparent', borderWidth: 0 }} onClick={toggleSwitch}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: isOn ? 'flex-end' : 'flex-start',
              width: '100px',
              height: '40px',
              backgroundColor: isOn ? '#f66301' : '#ccc',
              borderRadius: '20px',
              cursor: 'pointer',
              padding: '5px',
              transition: 'all 0.3s ease',
            }}
          >
            {!isOn && (
              <div
                style={{
                  width: '30px',
                  height: '30px',
                  backgroundColor: '#fff',
                  borderRadius: '50%',
                  boxShadow: '0 0 5px rgba(0,0,0,0.2)',
                }}
              />
            )}
            <span
              style={{
                marginLeft: 10,
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '12px',
                flex: 1,
              }}
            >
              {isOn ? yes2Text : no2Text}
            </span>
            {isOn && (
              <div
                style={{
                  width: '30px',
                  height: '30px',
                  backgroundColor: '#fff',
                  borderRadius: '50%',
                  boxShadow: '0 0 5px rgba(0,0,0,0.2)',
                }}
              />
            )}
          </div>
        </button>
      </div>
    </>
  );
};

SavedCreditCards.propTypes = {
  form: PropTypes.any,
  setPayLater: PropTypes.func,
  propIsOn: PropTypes.bool,
};

export default SavedCreditCards;
